import {environment} from "../../environments/environment";

export const BASE_API_URL = environment.BASE_API_URL;
export const BASE_IMG_URL = environment.BASE_IMG_URL;

export const AUTH_USER_STORAGE = 'cot-web.auth.user';
export const AUTH_TOKEN_STORAGE = 'cot-web.auth.token';

export const DEFAULT_CANS_PER_TASK = 6;



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/config/app.config.ts